import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowLeft, Handshake } from "lucide-react";
import { api, SITE } from "../lib/api";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function Partenaires() {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/partners?ts=${Date.now()}`)
      .then((r) => setPartners(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <main className="grain bg-[#050505] text-white min-h-screen" data-testid="partners-page">
      <Navbar />

      <section className="relative pt-40 pb-24 lg:pt-48 lg:pb-32 overflow-hidden">
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full bg-[#3B82F6]/15 blur-[140px] pointer-events-none" />

        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-zinc-400 hover:text-[#3B82F6] transition-colors mb-10" data-testid="partners-back-link">
            <ArrowLeft size={14} /> Retour au site
          </Link>

          <div className="max-w-3xl">
            <div className="text-xs uppercase tracking-[0.4em] text-[#3B82F6] inline-flex items-center gap-2">
              <Handshake size={14} /> Partenaires
            </div>
            <h1 className="font-display text-5xl md:text-7xl mt-4 leading-[0.9]">
              Nos partenaires<br />
              <span className="text-[#3B82F6]">de confiance.</span>
            </h1>
            <p className="text-zinc-400 mt-6 max-w-xl leading-relaxed">
              Une sélection d'acteurs locaux et de prestataires avec qui nous collaborons pour offrir des événements d'exception en Nouvelle-Aquitaine.
            </p>
          </div>

          {loading ? (
            <div className="mt-20 flex items-center justify-center text-zinc-500 gap-2"><Loader2 className="animate-spin" size={16} /> Chargement…</div>
          ) : partners.length === 0 ? (
            <div className="mt-20 glass-strong rounded-2xl p-12 text-center" data-testid="partners-empty">
              <Handshake size={32} className="text-zinc-600 mx-auto mb-4" />
              <div className="font-display text-2xl text-zinc-300">Bientôt nos partenaires</div>
              <p className="text-sm text-zinc-500 mt-2 max-w-md mx-auto">Cette rubrique est en cours de mise à jour. Reviens prochainement pour découvrir nos partenaires.</p>
            </div>
          ) : (
            <div className="mt-20 grid md:grid-cols-2 gap-6" data-testid="partners-grid">
              {partners.map((p, i) => (
                <article
                  key={p.id}
                  className="glass-strong rounded-2xl p-8 border border-white/10 hover:border-[#3B82F6]/50 hover:shadow-[0_0_30px_rgba(59,130,246,0.15)] transition-all duration-500 animate-fade-in"
                  style={{ animationDelay: `${i * 70}ms` }}
                  data-testid={`partner-card-${p.id}`}
                >
                  <div className="flex items-center gap-4 mb-6 flex-wrap">
                    {p.logos?.map((logo, idx) => (
                      <div key={idx} className="w-24 h-24 rounded-xl bg-white/95 p-3 flex items-center justify-center shadow-lg">
                        <img src={logo} alt={`${p.name} logo ${idx + 1}`} className="max-w-full max-h-full object-contain" />
                      </div>
                    ))}
                  </div>
                  <div className="font-display text-2xl">{p.name}</div>
                  {p.description && (
                    <p className="text-zinc-400 mt-3 text-sm leading-relaxed">{p.description}</p>
                  )}
                </article>
              ))}
            </div>
          )}

          <div className="mt-24 glass-strong rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <div className="text-xs uppercase tracking-[0.3em] text-[#3B82F6]">Devenir partenaire</div>
              <div className="font-display text-2xl mt-2">Travaillons ensemble.</div>
              <p className="text-sm text-zinc-400 mt-2 max-w-md">Vous êtes traiteur, photographe, vidéaste, organisateur ? Contactez Anton pour échanger.</p>
            </div>
            <a href={SITE.social.facebook} target="_blank" rel="noopener noreferrer" className="btn-neon shrink-0" data-testid="partners-contact-cta">
              Nous contacter
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
